var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"nav",class:{
    'active' : _vm.showHeader
  }},[(_vm.showHeader)?_c('booking-vehicle',{attrs:{"is-mobility":"","is-header":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }